$(function ($) {
  $(document).ready(function () {
    var $window = $(window);
    var formulaire = $("#form-contact");
    var button = $("#mobBtn");
    if ($(window).width() < 576) {
      $window.on("scroll", function () {
        var scrollTop = $window.scrollTop();
        var form_dist = formulaire.offset().top - 500;
        var form_height = $(formulaire).height() - 200;
        if (scrollTop < form_dist || scrollTop > form_dist + form_height) {
          button.css("display", "flex");
        } else {
          button.css("display", "none");
        }
      });
    }

    if (!$("#optin-oui").is(":checked") && !$("#optin-non").is(":checked")) {
      $(".radio-switch").addClass("init");
    } else {
      $(".radio-switch").removeClass("init");
    }
    $(".radio-switch-field").click(function () {
      if (!$("#optin-oui").is(":checked") && !$("#optin-non").is(":checked")) {
        $(".radio-switch").addClass("init");
      } else {
        $(".radio-switch").removeClass("init");
      }
    });
  });
});
